import { PillColor } from "../components/Pill/Pill";
import { PaymentStatus } from "../types/payment-statuses";

export type PAYMENT_STATUS = PaymentStatus;

export function getStatusesRaw(): PAYMENT_STATUS[] {
  return [PaymentStatus.UNKNOWN, PaymentStatus.PAID, PaymentStatus.PARTIALLY_PAID, PaymentStatus.NOT_PAID];
}

export function productTypeToTranslationKey(status: string | undefined): string {
  switch (status) {
    case 'dresses':
      return "orders.type.dress";
    case 'veils':
        return "orders.type.veils";
    case 'shoes':
        return "orders.type.shoes";
    default:
      return 'orders.payment.unknown';
  }
}

export function productTypeToIcon(status: string | undefined): string {
  switch (status) {
    case 'dresses':
      return '👗';
    case 'veils':
        return '👰';
    case 'shoes':
        return '👠';
    default:
      return '❔';
  }
}

export function paymentStatusToTranslationKey(status: PaymentStatus | undefined): string {
  switch (status) {
    case PaymentStatus.PAID:
      return "orders.payment.paid";
    case PaymentStatus.PARTIALLY_PAID:
        return "orders.payment.partially_paid";
    case PaymentStatus.NOT_PAID:
        return "orders.payment.not_paid";
    default:
      return 'orders.payment.unknown';
  }
}

export function paymentStatusToAbbreviatedTranslationKey(status: PaymentStatus | undefined): string {
  switch (status) {
    case PaymentStatus.PAID:
      return "orders.payment.paid.abbreviated";
    case PaymentStatus.PARTIALLY_PAID:
        return "orders.payment.partially_paid.abbreviated";
    case PaymentStatus.NOT_PAID:
        return "orders.payment.not_paid.abbreviated";
    default:
      return 'orders.payment.unknown.abbreviated';
  }
}

export function paymentStatusToPillColor(status: PaymentStatus | undefined, isSelfStore = false): PillColor {
  if (isSelfStore && status === PaymentStatus.PARTIALLY_PAID) return 'green';
  
  switch (status) {
    case PaymentStatus.PAID:
      return 'green';
    case PaymentStatus.PARTIALLY_PAID:
        return 'blue';
    case PaymentStatus.NOT_PAID:
        return 'red';
    default:
      return 'grey';
  }
}


export type BookingPaymentStatus = "SUCCEEDED" | "FAILED" | "PENDING" | "REFUNDED" | "DISPUTED" | "CANCELED" | "NOT_REQUIRED";

export function getBookingPaymentStatuses(): BookingPaymentStatus[] {
  return ['SUCCEEDED', 'FAILED', 'PENDING', 'REFUNDED', 'DISPUTED', 'CANCELED', 'NOT_REQUIRED'];
}

export function bookingPaymentStatusToTranslationKey(status: string | undefined): string {
  switch (status) {
    case 'SUCCEEDED':
      return "booking.feedback.payment_status.paid";
    case 'FAILED':
      return "booking.feedback.payment_status.failed";
    case 'PENDING':
      return "booking.feedback.payment_status.pending";
    case 'REFUNDED':
      return "booking.feedback.payment_status.refunded";
    case 'DISPUTED':
      return "booking.feedback.payment_status.disputed";
    case 'CANCELED':
      return "booking.feedback.payment_status.canceled";
    case 'NOT_REQUIRED':
      return "booking.feedback.payment_status.not_required";
    default:
      return "global.unknown";
  }
}

export function bookingPaymentStatusToPillColor(status: BookingPaymentStatus | string | undefined): PillColor {
  switch (status) {
    case 'SUCCEEDED':
      return 'green';
    case 'PENDING':
      return 'yellow';
    case 'FAILED':
    case 'CANCELED':
      return 'red';
    case 'REFUNDED':
    case 'DISPUTED':
      return 'grey';
    case 'NOT_REQUIRED':
    default:
      return 'grey';
  }
}